import connection from '@/store/modules/storage/sse/connection';
import dataProcessor from '@/store/modules/storage/sse/dataProcessor';

export default {
    connection,
    dataProcessor,
};
